export class LicitacaoDadosCancelamento {
  IdLicitacao: number;
  FlSituacao: string;

  DtAnulacaoCertame: Date;
  DeMotivoAnulCertame: string;
  DtRevogacaoCertame: Date;
  DeMotivoRevogCertame: string;
  DtFracassoCertame: Date;
  DeMotivoFracassoCertame: string;
  DtDesercaoCertame: Date;
  DeMotivoDesercaoCertame: string;

  tratarDadosDaAPI(): void {
    if (this.DtAnulacaoCertame) {
      this.DtAnulacaoCertame = new Date(this.DtAnulacaoCertame);
    }
    if (this.DtRevogacaoCertame) {
      this.DtRevogacaoCertame = new Date(this.DtRevogacaoCertame);
    }
    if (this.DtFracassoCertame) {
      this.DtFracassoCertame = new Date(this.DtFracassoCertame);
    }
    if (this.DtDesercaoCertame) {
      this.DtDesercaoCertame = new Date(this.DtDesercaoCertame);
    }
  }

  getData(): Date | null {
    switch (this.FlSituacao) {
      case "AN":
        return this.DtAnulacaoCertame;
      case "RE":
        return this.DtRevogacaoCertame;
      case "DE":
        return this.DtDesercaoCertame;
      case "FR":
        return this.DtFracassoCertame;
      default:
        return null;
    }
  }

  getMotivo(): string | null {
    switch (this.FlSituacao) {
      case "AN":
        return this.DeMotivoAnulCertame;
      case "RE":
        return this.DeMotivoRevogCertame;
      case "DE":
        return this.DeMotivoDesercaoCertame;
      case "FR":
        return this.DeMotivoFracassoCertame;
      default:
        return null;
    }
  }
}
